<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
  214 West 29th St., Suite 1003<br/>
  New York NY 10001<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 1998 and 2002 by Éditions Gallimard, Paris<br/>
  First publication 2007 by Europa Editions<br/>
<br/>
  Translation by Howard Curtis<br/>
  Original Title: <i>Solea<br/></i>Translation copyright © 2007 by Europa Editions<br/>
<em>Eulogy for Jean-Claude Izzo</em> © 2006 by Massimo Carlotto, <br/>
translation from the Italian by Michael Reynolds<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  This work has been published thanks to support from the French Ministry of Culture – Centre National du Livre<br/>
Ouvrage publié avec le concours du Ministère Français chargé de la Culture – Centre National du Livre<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
<br/>
  ISBN 9781609453954 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?596ddb3c